import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const ConnectVistas = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}☰
        </div>

        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-vistas">Counselling</Link>
          </li>
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          <li>
            <Link to="/update-vistas">Updates</Link>
          </li>
          <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li>
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
        </Slider>
      </div>
      <div className="padding-wid">
        <div class="container">
          <div class="text-center d-block">
            <h3 class="mx-auto text-black mb-4  font-play">Connect with Us</h3>
          </div>
          <div class="row">
            <div class="col-md-12 textarea">
              <h4 className="font-play">For appointments, write to us at:</h4>
              <section>
                <ul class="list">
                  <li>Sangeeta.goyal@lotusvalleygurgaon.com</li>
                  <li>counsellors@lotusvalleygurgaon.com</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div>
    </>
  );
};
export default ConnectVistas;
